import { render } from "./TabelaModulosAtivos.vue?vue&type=template&id=15bd729d&scoped=true"
import script from "./TabelaModulosAtivos.vue?vue&type=script&lang=js"
export * from "./TabelaModulosAtivos.vue?vue&type=script&lang=js"

import "./TabelaModulosAtivos.vue?vue&type=style&index=0&id=15bd729d&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bd729d"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTd,QBtn});
